import React, { Component } from 'react';
import PropTypes from 'prop-types';

import EstacioIntroduccioHistoricObservadorsAfegir from './estacioIntroduccioHistoricObservadorsAfegir';
import EstacioIntroduccioHistoricObservadorsTaula from './estacioIntroduccioHistoricObservadorsTaula';

class EstacioIntroduccioHistoricObservadors extends Component {
    render() {
        const { dataActualText, dataBaixaEstacioText } = this.props;
        return (
            <div className="estacio-introduccio-historic-observadors">
                <EstacioIntroduccioHistoricObservadorsAfegir dataActualText={dataActualText} dataBaixaEstacioText={dataBaixaEstacioText}/>
                <EstacioIntroduccioHistoricObservadorsTaula dataActualText={dataActualText} dataBaixaEstacioText={dataBaixaEstacioText}/>
            </div>
        );
    }
}

EstacioIntroduccioHistoricObservadors.propTypes = {
    dataActualText: PropTypes.string.isRequired,
    dataBaixaEstacioText: PropTypes.string
};

export default EstacioIntroduccioHistoricObservadors;



// WEBPACK FOOTER //
// ./src/components/estacio/estacioIntroduccioHistoricObservadors.js